export const entryQuestionnairePath = 'entry-questionnaire';
